const agGridReact = require('../../node_modules/ag-grid-react/dist/package/index.cjs.js')

module.exports = {
    AgGridReact: agGridReact.AgGridReact,
    AgGridProvider: agGridReact.AgGridProvider,
}
